export const copyToClipboard = (text: string) => {
  const elementTemporary = document.createElement('textarea')
  document.body.appendChild(elementTemporary)
  elementTemporary.value = text
  elementTemporary.select()
  document.execCommand('copy')
  document.body.removeChild(elementTemporary)
}
